import {Component, computed} from '@angular/core';
import {routingMetadata} from '../../signal/common/routing-matadata.signal';
import {ComponentMetadata} from '../../model/component-metadata.model';
import {landingSectionsSignal} from '../../signal/common/landing-sections.signal';
import {NgIcon, provideIcons} from '@ng-icons/core';
import {tablerBrandFacebook, tablerBrandLinkedin} from '@ng-icons/tabler-icons';
import {Contact} from '../../model/routing-metadata.model';
import {NavigatorDirective} from '../../directive/navigator.directive';
import {PixelEventName} from '../../analytics/meta/types/pixel.types';
import {PixelService} from '../../analytics/meta/pixel.service';
import {GoogleAnalyticsService} from '../../analytics/google/google-analytics.service';
import {AnalyticsEventCategory, AnalyticsEventName} from '../../enum/gtm-cookie-consent.enum';
import {MicrosoftClarityService} from '../../analytics/microsoft/microsoft-clarity.service';
import {MicrosoftClarityEvents} from '../../analytics/microsoft/types/microsoft-clarity-events.enum';
import {environment} from '../../../environments/environment';

enum SocialMediaType {
  Facebook = 'facebook',
  Linkedin = 'linkedin'
}

@Component({
  selector: 'app-footer',
  imports: [
    NgIcon,
    NavigatorDirective
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  providers: [provideIcons({
    tablerBrandFacebook,
    tablerBrandLinkedin
  })]
})
export class FooterComponent {
  protected currentYear: number;
  protected logotypeUrl = computed(() => routingMetadata()?.logotypeUrl);
  protected label = computed(() => routingMetadata()?.label);
  protected sections = computed<ComponentMetadata[]>(() => landingSectionsSignal());
  protected contact = computed<Contact | undefined>(() => routingMetadata()?.contact);
  protected readonly socialMediaUrls = {
    facebook: 'https://www.facebook.com/processwaypl',
    linkedinPw: 'https://www.linkedin.com/company/process-way',
    linkedinSh: 'https://www.linkedin.com/company/processway-software-house',
  }
  protected readonly facebookSocialMediaType: SocialMediaType = SocialMediaType.Facebook
  protected readonly linkedinSocialMediaType: SocialMediaType = SocialMediaType.Linkedin
  protected privacyPolicyUrl = environment.privacyPolicyUrl;

  constructor(
    private readonly pixelService: PixelService,
    private readonly googleAnalyticsService: GoogleAnalyticsService,
    private readonly microsoftClarityService: MicrosoftClarityService
  ) {
    this.currentYear = new Date().getFullYear();
  }

  protected trackSocialMediaClick(type: SocialMediaType): void {
    try {

      switch (type) {
        case SocialMediaType.Facebook:
          this.pixelService.trackEvent(
            PixelEventName.SocialClickFacebook, {
              platform: 'facebook'
            });

          this.googleAnalyticsService.trackEvent({
            event: AnalyticsEventName.FacebookClick,
            eventCategory: AnalyticsEventCategory.SocialClick,
            eventPayload: SocialMediaType.Facebook
          });

          this.microsoftClarityService.trackEvent(MicrosoftClarityEvents.SocialClickFacebook);

          break;

        case SocialMediaType.Linkedin:
          this.pixelService.trackEvent(
            PixelEventName.SocialClickLinkedIn, {
              platform: 'linkedin'
            });

          this.googleAnalyticsService.trackEvent({
            event: AnalyticsEventName.LinkedinClick,
            eventCategory: AnalyticsEventCategory.SocialClick,
            eventPayload: SocialMediaType.Linkedin
          });

          this.microsoftClarityService.trackEvent(MicrosoftClarityEvents.SocialClickLinkedIn);

          break;

        default:
          break;
      }
    } catch (e) {
      console.error(e);
    }
  }

  protected trackEmailClick(email: string): void {
    this.pixelService.trackEvent(PixelEventName.EmailClick, {email});

    this.googleAnalyticsService.trackEvent(
      {
        event: AnalyticsEventName.EmailClick,
        eventCategory: AnalyticsEventCategory.Contact,
        eventPayload: email
      }
    );

    this.microsoftClarityService.trackEvent(MicrosoftClarityEvents.EmailClick)
  }
}

